import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import HowItWorksSection from '@/pages/home/components/HowItWorksSection';
import WhySection from '@/pages/home/components/WhySection';
import PricingSection from '@/pages/home/components/PricingSection';
import CTASection from '@/pages/home/components/CTASection';
import ComplianceSection from '@/pages/home/components/ComplianceSection';

const structuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'CotIdel - Intelligence de Cotation Infirmière',
  description: 'Première intelligence artificielle experte de cotation infirmière en France. Analyse les situations cliniques, explique chaque cotation NGAP, et sécurise la facturation des IDEL.',
  applicationCategory: 'HealthApplication',
  operatingSystem: 'Web',
  offers: {
    '@type': 'Offer',
    price: '5.99',
    priceCurrency: 'EUR',
  },
};

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.animate-on-scroll').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HowItWorksSection />
          <WhySection />
          <PricingSection />
          <ComplianceSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}